import React from "react";
import ReactWOW from 'react-wow';
import { $t } from '@/modules/i18n';

class About extends React.Component {
  render() {
    const { Message: msg } = this.props;
    const { intro, about = {}, categories = {} } = msg;
    
    return (
      <section id="about">
        <div className="container">
          <div className="title-block">
            <h2 className="intro-title">{$t(intro.title)}</h2>
          </div>
          {
            (intro.desc || []).map(item => (
              <div key={item.text}>
                <p>{$t(item.text)}</p>
                <ul>
                {
                  (item.list || []).map(desc => <li key={desc}>{$t(desc)}</li>)
                }
                </ul>
              </div>
            ))
          }
          {/* Host */}
          {
            (msg.hostedByData || []).map((item, index) => {
              return (
                <ReactWOW animation="fadeInUp" delay="0.1s" key={index}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer" className="hosted">
                    <p className="name">{$t($t(msg.hostedBy))}</p>
                    <img src={require("@ndsc/assets/images/partners/" + item.image)} alt={$t(item.name)} className="img-logo" />
                  </a>
                </ReactWOW>
              )
            })
          }
          {/* Organized */}
          {
            (msg.organizedData || []).map((item, index) => {
              return (
                <ReactWOW animation="fadeInUp" delay="0.1s" key={index}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer" className="hosted">
                    <p className="name">{$t(msg.organized)}</p>
                    <img src={require("@ndsc/assets/images/partners/" + item.image)} alt="Shopee" className="img-logo shopee" />
                  </a>
                </ReactWOW>
              )
            })
          }
          <h2 className="h2-2">{$t(about.title)}</h2>
          {
            (about.desc || []).map(item => <p key={item}>{$t(item)}</p>)
          }
          <div className="flex-box">
            {
              (about.data || []).map((item, index) => {
                return (
                  <ReactWOW animation="fadeInUp" delay="0.1s" key={index}>
                    <div className="box box-2">
                      <h4>
                        <img src={require("@ndsc/assets/images/" + item.image)} style={{ width: "40px", marginRight: "12px" }} alt={$t(item.name)} />
                        {$t(item.title)}</h4>
                      <p>{$t(item.desc)}</p>
                      {item.desc02 ? <p>{$t(item.desc02)}</p> : null}
                    </div>
                  </ReactWOW>
                )
              })
            }
          </div>
          <p className="note">
            {$t(about.note)}
          </p>
          <h2 className="h2-2">{$t(categories.title)}</h2>
          <div className="flex-box cate">
            {
              (categories.data || []).map((item, index) => {
                return (
                  <ReactWOW animation="fadeInUp" delay="0.1s" key={index}>
                    <div className="box box-2">
                      <img src={require("@ndsc/assets/images/" + item.image)} alt={$t(item.title)} />
                      <h4>{$t(item.title)}</h4>
                      <ul>
                        {
                          item.list.map((i, index) => {
                            return (
                              <li key={index}>{$t(i)}</li>
                            )
                          })
                        }
                      </ul>
                    </div>
                  </ReactWOW>
                )
              })
            }
          </div>
        </div>
      </section >
    )
  }
}

export default About;